// Growth cards: only the padded square 528px canvases get cover-cropped; tight
// exports are flagged is-wide (diagrams) or is-tight (shown whole, contained).
export default function initGrowthMedia() {
  document.querySelectorAll('.kd-growth-card__media img').forEach((img) => {
    const flag = () => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      const ratio = img.naturalWidth / img.naturalHeight;
      const media = img.closest('.kd-growth-card__media');
      if (ratio >= 2) media.classList.add('is-wide');
      else if (Math.abs(ratio - 1) > 0.05) media.classList.add('is-tight');
    };

    if (img.complete) flag();
    else img.addEventListener('load', flag, { once: true });
  });
}
